<template>
  <div>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-title class="h-f-b">Choose Unavailability</ion-title>
        <ion-buttons slot="start">
          <ion-button @click="close()">
            <font-awesome-icon
              slot="icon-only"
              icon="times"
            ></font-awesome-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <v-date-picker
        @update:from-page="pageChange"
        @dayclick="toggleUnavailability"
        is-expanded
        v-bind:theme="theme"
        v-bind:min-page="minMonthPage"
        v-bind:max-page="maxMonthPage"
        mode="multiple"
        is-inline
        show-caps
        v-model="datesUnavailable"
        :from-page.sync="fromPage"
        :to-page.sync="toPage"
      ></v-date-picker>

      <error-message v-if="error" v-bind:message="error"></error-message>

      <div class="ion-text-center">
        <p>Select a date to set as unavailable.</p>
      </div>
    </ion-content>
  </div>
</template>

<script>
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import shiftsApiService from "../services/ShiftsApi";
import moment from "moment";

export default {
  name: "ShiftUnavailabilityModal",
  components: {
    "v-date-picker": DatePicker,
  },
  data() {
    return {
      attrs: [
        {
          key: "shifts",
          highlight: true,
          dates: [],
        },
      ],
      theme: {
        // https://github.com/nathanreyes/v-calendar/blob/next/src/utils/defaults/theme.js
        color: "pink",
        container: {
          light: "custom-container",
        },
        header: {
          light: "custom-header",
        },
        title: {
          light: "custom-title",
        },
        weekdays: {
          light: "custom-weekday",
        },
        navArrows: {
          light:
            "vc-leading-snug vc-rounded vc-border-2 vc-border-transparent hover:vc-bg-gray-900 focus:vc-border-{color}-600",
        },
        dayContent:
          "custom-day-content vc-font-medium vc-text-sm vc-cursor-pointer focus:vc-font-bold vc-rounded-full",
      },
      minMonthPage: {},
      maxMonthPage: {},
      currentDate: "",
      datesUnavailable: [],
      fromPage: null,
      toPage: null,
      error: false,
    };
  },

  methods: {
    async pageChange() {
      const loading = await this.$ionic.loadingController.create({
        message: "Loading shifts...",
      });

      loading.present();

      try {
        const screenData = await shiftsApiService.getUnavailability();

        // Set current month
        const currentDate = screenData.current_date;
        this.currentDate = moment(currentDate).format("YYYY-MM-DD");
        // eslint-disable-next-line no-console
        console.log(currentDate);

        const currentMonth = moment(currentDate).month() + 1;
        const currentYear = moment(currentDate).year();

        this.minMonthPage = {
          month: currentMonth,
          year: currentYear,
        };

        this.maxMonthPage = this.minMonthPage;

        this.fromPage = { month: currentMonth, year: currentYear };
        this.toPage = { month: currentMonth, year: currentYear };

        // Get dates
        const datesSet = screenData.dates_unavailable;

        this.datesUnavailable = datesSet.map((shift) => new Date(shift.date));
      } catch (error) {
        this.error = error;
      } finally {
        loading.dismiss();
      }
    },
    close() {
      return this.$ionic.modalController.dismiss();
    },

    async toggleUnavailability(event) {
      const loading = await this.$ionic.loadingController.create({
        message: "Updating avalability...",
      });

      loading.present();

      const dateIndex = this.datesUnavailable.findIndex((o) => {
        // eslint-disable-next-line no-console
        console.log(o.getTime(), "next: " + event.date.getTime());
        return o.getTime() === event.date.getTime();
      });

      // eslint-disable-next-line no-console
      console.log(this.datesUnavailable, dateIndex);

      try {
        if (dateIndex >= 0) {
          await shiftsApiService.setUnavailability(event.id);
          this.datesUnavailable.push(event.date);
        } else {
          await shiftsApiService.unsetUnavailability(event.id);
          this.datesUnavailable.splice(dateIndex, 1);
        }
      } catch (error) {
        this.error = error;
      } finally {
        loading.dismiss();
      }
      loading.dismiss();
    },
  },
};
</script>
